import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import $ from "jquery";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import Select from "react-select";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import { formateDateWithMonth } from "../../../../utils/commonfunction";
import * as ratingServices from "../../services/rating.services";
import { GetAllAstrologer } from "../../services/psychic.services";
import { useTranslation } from "react-i18next";

const RatingList = () => {
  const params = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState(false);
  const [datalength, setDataLength] = useState(0);
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({ column: "createdAt", order: -1 });
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [globalsearch, setGlobalSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  // Add Review Modal State
  const [showModal, setShowModal] = useState(false);
  const [astrologers, setAstrologers] = useState([]);
  const [astroSearch, setAstroSearch] = useState("");
  const [astroLoader, setAstroLoader] = useState(false);
  const [selectedAstroOption, setSelectedAstroOption] = useState(null);
  
  // Add Review Form State
  const [ratingVal, setRatingVal] = useState("5");
  const [feedbackText, setFeedbackText] = useState("");
  const [reviewerName, setReviewerName] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [astroError, setAstroError] = useState("");

  // Reply Modal State
  const [showReplyModal, setShowReplyModal] = useState(false);
  const [selectedRatingForReply, setSelectedRatingForReply] = useState(null);
  const [replyInput, setReplyInput] = useState("");
  const [replySubmitting, setReplySubmitting] = useState(false);

  const breadcrumbs = [
    { title: t("link_dashboard") || "Dashboard", url: "/admin/dashboard" },
    { title: "Ratings & Reviews", url: "" },
  ];

  // Fetch reviews list
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoader(true);
      const pg = params.pgno ? parseInt(params.pgno) : page;
      const formData = new FormData();
      formData.append("page", pg);
      formData.append("per_page", itemperpage);
      formData.append("sort", JSON.stringify(sorting));
      formData.append("global_search", globalsearch);
      if (statusFilter !== "all") {
        formData.append("status", statusFilter);
      }

      ratingServices
        .List(formData)
        .then((res) => {
          setList(res.data.list || []);
          setDataLength(res.data.total_records || 0);
          setLoader(false);
        })
        .catch((err) => {
          console.error("Fetch reviews error: ", err);
          setLoader(false);
        });
    }, 300);

    return () => clearTimeout(timer);
  }, [location, page, params.pgno, sorting, globalsearch, statusFilter, statsupdate]);

  // Fetch astrologers list for dropdown
  useEffect(() => {
    if (!showModal) return;
    const timer = setTimeout(() => {
      fetchAstrologers(astroSearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [astroSearch, showModal]);

  const fetchAstrologers = (searchTerm = "") => {
    setAstroLoader(true);
    GetAllAstrologer()
      .then((res) => {
        if (res && res.success) {
          const list = Array.isArray(res.data) ? res.data : [];
          const filtered = searchTerm
            ? list.filter((a) => a.name?.toLowerCase().includes(searchTerm.toLowerCase()))
            : list;
          setAstrologers(filtered);
        }
        setAstroLoader(false);
      })
      .catch((err) => {
        console.error("Error loading astrologers: ", err);
        setAstroLoader(false);
      });
  };

  const handleSort = (column) => {
    setDefaultSorting(false);
    let order = sorting.column === column && sorting.order === 1 ? -1 : 1;
    setSorting({ column, order });
  };

  const resetFilter = () => {
    setGlobalSearch("");
    setStatusFilter("all");
    setSorting({ column: "createdAt", order: -1 });
  };

  // Change review status (Approve / Reject)
  const handleChangeStatus = (id, status) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t(`Are you sure you want to ${status.toLowerCase()} this review?`),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes") || "Yes",
      cancelButtonText: t("btn_cancel") || "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        ratingServices
          .ChangeStatus({ id, status })
          .then((res) => {
            if (res.success || res.status === 200) {
              Swal.fire({
                icon: "success",
                text: res.message || `Review successfully ${status.toLowerCase()}ed!`,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: res.message || "Failed to update review status",
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((err) => {
            console.error(err);
            Swal.fire("Error", "Something went wrong", "error");
          });
      }
    });
  };

  // Delete review
  const handleDelete = (id) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure") || "Are you sure?",
      text: t("you_not_be_able_to_revert_this") || "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_delete") || "Yes, delete it",
      cancelButtonText: t("btn_cancel") || "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        ratingServices
          .Delete({ id })
          .then((res) => {
            if (res.success || res.status === 200) {
              Swal.fire({
                icon: "success",
                text: res.message || "Review deleted successfully",
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: res.message || "Failed to delete review",
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((err) => {
            console.error(err);
            Swal.fire("Error", "Something went wrong", "error");
          });
      }
    });
  };

  // Add Review Submit
  const handleAddReviewSubmit = (e) => {
    e.preventDefault();
    if (!selectedAstroOption) {
      setAstroError("Please select an astrologer");
      return;
    }
    setAstroError("");

    const name = reviewerName.trim();
    if (!name) {
      Swal.fire("Error", "Please enter the reviewer's name", "error");
      return;
    }

    setSubmitting(true);
    ratingServices
      .Add({
        astrologer_id: selectedAstroOption.value,
        rating: ratingVal,
        feedback: feedbackText,
        reviewer_name: name,
      })
      .then((res) => {
        setSubmitting(false);
        if (res.success || res.status === 200) {
          Swal.fire("Success", "Review added successfully", "success");
          setShowModal(false);
          // Reset fields
          setSelectedAstroOption(null);
          setAstroError("");
          setRatingVal("5");
          setFeedbackText("");
          setReviewerName("");
          setStatusUpdate(!statsupdate);
        } else {
          Swal.fire("Error", res.message || "Failed to add review", "error");
        }
      })
      .catch((err) => {
        setSubmitting(false);
        console.error(err);
        Swal.fire("Error", err.message || "Failed to add review", "error");
      });
  };

  // Reply Handlers
  const handleOpenReplyModal = (row) => {
    setSelectedRatingForReply(row);
    setReplyInput(row.astrologer_reply || "");
    setShowReplyModal(true);
  };

  const handleReplySubmit = (e) => {
    e.preventDefault();
    if (!selectedRatingForReply) return;

    setReplySubmitting(true);
    ratingServices
      .Reply({
        id: selectedRatingForReply.id,
        astrologer_reply: replyInput,
      })
      .then((res) => {
        setReplySubmitting(false);
        if (res.success || res.status === 200) {
          Swal.fire("Success", res.message || "Reply updated successfully", "success");
          setShowReplyModal(false);
          setSelectedRatingForReply(null);
          setReplyInput("");
          setStatusUpdate(!statsupdate);
        } else {
          Swal.fire("Error", res.message || "Failed to update reply", "error");
        }
      })
      .catch((err) => {
        setReplySubmitting(false);
        console.error(err);
        Swal.fire("Error", err.message || "Failed to update reply", "error");
      });
  };

  const astroOptions = astrologers.map((a) => ({
    value: a.id,
    label: a.name,
    phone: a.phone_number || null,
  }));

  const customOption = (data) => (
    <div className="d-flex justify-content-between align-items-center">
      <span>{data.label}</span>
      {data.phone && <small className="text-muted ms-2">({data.phone})</small>}
    </div>
  );

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            
            {/* Header and filters */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label mb-0">Ratings & Reviews Management</h6>
              <div className="d-flex align-items-center gap-2">
                
                {/* Search Bar */}
                <div className="form-group mb-0 me-2">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search by User, Astro, Feedback or Reply..."
                      value={globalsearch}
                      onChange={(e) => setGlobalSearch(e.target.value)}
                    />
                  </div>
                </div>

                {/* Status Filter */}
                <div className="me-2">
                  <div className="form-group mb-0 filter_icon_container filter_design">
                    <i className="fa fa-filter mr-2 filter_icon"></i>
                    <div className="select-down-arrow">
                      <select
                        className="form-control cp"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <option value="all">All Reviews</option>
                        <option value="Pending">Pending Approval</option>
                        <option value="Approved">Approved</option>
                        <option value="Rejected">Rejected</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Reset Filters */}
                <button className="btn btn-outline-warning me-2" onClick={resetFilter}>
                  Reset
                </button>

                {/* Add Review Button */}
                <button
                  className="btn ripple btn-main-primary signbtn"
                  onClick={() => {
                    setAstroSearch("");
                    setSelectedAstroOption(null);
                    setAstroError("");
                    setShowModal(true);
                  }}
                >
                  <i className="fa fa-plus me-1"></i> Add Review
                </button>
              </div>
            </div>

            {/* List Table */}
            <div className="table-responsive">
              <table className="table table-bordered text-nowrap w-100">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>User</th>
                    <th>Astrologer</th>
                    <th>Rating</th>
                    <th>Feedback / Comments</th>
                    <th>Status</th>
                    <th>Created At</th>
                    <th className="action_head">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        <Loader />
                      </td>
                    </tr>
                  ) : list.length > 0 ? (
                    list.map((row, i) => {
                      const pg = params.pgno ? parseInt(params.pgno) : page;
                      return (
                        <tr key={row.id}>
                          <td>{(pg - 1) * itemperpage + i + 1}</td>
                          <td>
                            {row.is_admin_added ? (
                              <div>
                                <strong>{row.reviewer_name || "Admin Review"}</strong>
                                <br />
                                <span className="badge bg-info-light text-info rounded-pill mt-1">Admin Added</span>
                              </div>
                            ) : (
                              <div>
                                <strong>{row.user?.name || "N/A"}</strong>
                                {row.user?.email && <div className="text-muted small">{row.user.email}</div>}
                              </div>
                            )}
                          </td>
                          <td>
                            <strong>{row.astrologer?.name || "N/A"}</strong>
                            {row.astrologer?.email && <div className="text-muted small">{row.astrologer.email}</div>}
                          </td>
                          <td>
                            <div className="text-warning">
                              {Array.from({ length: 5 }).map((_, idx) => (
                                <i
                                  key={idx}
                                  className={`fa fa-star ${idx < row.rating ? "text-warning" : "text-light"}`}
                                  style={{ color: idx < row.rating ? "#FFC107" : "#E4E6EF", marginRight: "2px" }}
                                />
                              ))}
                              <span className="ms-1 text-muted">({row.rating})</span>
                            </div>
                          </td>
                          <td style={{ whiteSpace: "normal", minWidth: "280px" }}>
                            <div className="mb-2">
                              <strong>User Comment:</strong>
                              <div className="text-dark mt-1">
                                {row.feedback || <span className="text-muted italic">No comment provided</span>}
                              </div>
                            </div>
                            {row.astrologer_reply ? (
                              <div className="p-2 bg-light rounded border-start border-3 border-primary mt-2">
                                <div className="d-flex align-items-center justify-content-between mb-1">
                                  <span className="badge bg-primary text-white">
                                    <i className="fa fa-reply me-1"></i> Astrologer Reply
                                  </span>
                                  {row.reply_date && (
                                    <small className="text-muted" style={{ fontSize: "11px" }}>
                                      {formateDateWithMonth(row.reply_date)}
                                    </small>
                                  )}
                                </div>
                                <div className="small text-dark fw-normal">{row.astrologer_reply}</div>
                              </div>
                            ) : (
                              <div className="mt-1">
                                <span className="badge bg-light text-muted border" style={{ fontSize: "11px" }}>
                                  No reply yet
                                </span>
                              </div>
                            )}
                          </td>
                          <td>
                            <span
                              className={`badge badge-${
                                row.status === "Approved"
                                  ? "success"
                                  : row.status === "Rejected"
                                  ? "danger"
                                  : "warning"
                              }`}
                            >
                              {row.status}
                            </span>
                          </td>
                          <td>{row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                          <td>
                            <div className="d-flex gap-2 flex-wrap">
                              <button
                                className="btn btn-sm btn-info"
                                onClick={() => handleOpenReplyModal(row)}
                                title={row.astrologer_reply ? "Edit Reply" : "Add Reply"}
                              >
                                <i className="fa fa-reply me-1"></i> {row.astrologer_reply ? "Edit Reply" : "Reply"}
                              </button>
                              {row.status !== "Approved" && (
                                <button
                                  className="btn btn-sm btn-success"
                                  onClick={() => handleChangeStatus(row.id, "Approved")}
                                  title="Approve Review"
                                >
                                  <i className="fa fa-check"></i> Approve
                                </button>
                              )}
                              {row.status !== "Rejected" && (
                                <button
                                  className="btn btn-sm btn-warning"
                                  onClick={() => handleChangeStatus(row.id, "Rejected")}
                                  title="Reject Review"
                                >
                                  <i className="fa fa-times"></i> Reject
                                </button>
                              )}
                              <button
                                className="btn btn-sm btn-danger"
                                onClick={() => handleDelete(row.id)}
                                title="Delete Review"
                              >
                                <i className="fa fa-trash"></i> Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No reviews found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="mt-3 d-flex justify-content-between align-items-center">
              <b>Total Records: {datalength}</b>
              {datalength > 0 && (
                <CustomPagination
                  datalength={datalength}
                  itemperpage={itemperpage}
                  currentPage={params.pgno ? parseInt(params.pgno) : page}
                  setPage={setPage}
                  pageRoute={[
                    { name: "Ratings", path: "/admin/rating/list" },
                  ]}
                />
              )}
            </div>

          </div>
        </div>
      </div>

      {/* Add Review Modal */}
      <Modal 
        show={showModal} 
        onHide={() => {
          setShowModal(false);
          setAstroError("");
        }} 
        centered 
        size="lg" 
        style={{ visibility: "visible", pointerEvents: "initial" }}
      >
        <Form onSubmit={handleAddReviewSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Write a Review for Astrologer</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            
            {/* Select Astrologer */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Select Astrologer <span className="text-danger">*</span></Form.Label>
              <Select
                options={astroOptions}
                formatOptionLabel={customOption}
                onChange={(val) => {
                  setSelectedAstroOption(val);
                  setAstroError("");
                }}
                value={selectedAstroOption}
                placeholder="Search and select astrologer..."
                isLoading={astroLoader}
                isClearable
                isSearchable
                onInputChange={(val) => setAstroSearch(val)}
                noOptionsMessage={() => "Type to search..."}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  control: (base) => ({
                    ...base,
                    minHeight: 45,
                    borderRadius: 6,
                  }),
                }}
              />
              {astroError && <div className="text-danger mt-1 small">{astroError}</div>}
            </Form.Group>

            {/* Reviewer Name */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Reviewer Name <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="text"
                maxLength={100}
                placeholder="Name of the client who gave this review"
                value={reviewerName}
                onChange={(e) => setReviewerName(e.target.value)}
                style={{ height: 45, borderRadius: 6 }}
              />
            </Form.Group>

            {/* Rating Stars */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Rating <span className="text-danger">*</span></Form.Label>
              <Form.Select
                value={ratingVal}
                onChange={(e) => setRatingVal(e.target.value)}
                style={{ height: 45, borderRadius: 6 }}
              >
                <option value="5">⭐⭐⭐⭐⭐ (5 Stars)</option>
                <option value="4">⭐⭐⭐⭐ (4 Stars)</option>
                <option value="3">⭐⭐⭐ (3 Stars)</option>
                <option value="2">⭐⭐ (2 Stars)</option>
                <option value="1">⭐ (1 Star)</option>
              </Form.Select>
            </Form.Group>

            {/* Review/Comments */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Review Comments</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Write review comments or feedback here..."
                value={feedbackText}
                onChange={(e) => setFeedbackText(e.target.value)}
              />
            </Form.Group>

          </Modal.Body>
          <Modal.Footer>
            <Button className="btn ripple btn-dark" onClick={() => {
              setShowModal(false);
              setAstroError("");
            }}>
              Cancel
            </Button>
            <Button className="btn ripple btn-main-primary signbtn" type="submit" disabled={submitting}>
              {submitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-1" /> Submitting...
                </>
              ) : (
                "Submit Review"
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Reply Modal */}
      <Modal
        show={showReplyModal}
        onHide={() => {
          setShowReplyModal(false);
          setSelectedRatingForReply(null);
        }}
        centered
        style={{ visibility: "visible", pointerEvents: "initial" }}
      >
        <Form onSubmit={handleReplySubmit}>
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedRatingForReply?.astrologer_reply ? "Edit Astrologer Reply" : "Add Astrologer Reply"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedRatingForReply && (
              <div className="mb-3 p-3 bg-light rounded">
                <div className="mb-1">
                  <strong>User:</strong> {selectedRatingForReply.user?.name || selectedRatingForReply.reviewer_name || "Guest"}
                </div>
                <div className="mb-1">
                  <strong>Astrologer:</strong> {selectedRatingForReply.astrologer?.name || "N/A"}
                </div>
                <div>
                  <strong>User Comment:</strong> {selectedRatingForReply.feedback || "No feedback"}
                </div>
              </div>
            )}

            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Astrologer Reply</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Write reply response here..."
                value={replyInput}
                onChange={(e) => setReplyInput(e.target.value)}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn ripple btn-dark"
              onClick={() => {
                setShowReplyModal(false);
                setSelectedRatingForReply(null);
              }}
            >
              Cancel
            </Button>
            <Button className="btn ripple btn-main-primary signbtn" type="submit" disabled={replySubmitting}>
              {replySubmitting ? (
                <>
                  <Spinner animation="border" size="sm" className="me-1" /> Saving...
                </>
              ) : (
                "Save Reply"
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default RatingList;
